module.exports = __webpack_public_path__ + "img/CO.416b9e28.svg";